'use client';

import { createContext } from 'react';

import type { ConsentScriptsContextValue } from './consent-scripts-provider.types';

/**
 * Consent scripts context. `undefined` when no `ConsentScriptsProvider` is
 * mounted (flag off, or a placement outside the survey layouts), in which case
 * the PII plates load the scripts themselves as before.
 */
export const ConsentScriptsContext = createContext<
  ConsentScriptsContextValue | undefined
>(undefined);
